import { render } from "./getConsultation.vue?vue&type=template&id=283e7f98&scoped=true"
import script from "./getConsultation.vue?vue&type=script&lang=js"
export * from "./getConsultation.vue?vue&type=script&lang=js"

import "./getConsultation.vue?vue&type=style&index=0&id=283e7f98&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283e7f98"]])

export default __exports__